import QuillDelta from "quill-delta";
import { SingleOperation } from "../operations/Operation";
import { Verb } from "../types/Verb";
import { TextShape2 } from "./TextShape";
import { makeAttributeList } from "../ShapeStore";

export default class AddTextOperation extends SingleOperation {
  shape: TextShape2;

  constructor(newShapeID: string, shape: TextShape2, contents: QuillDelta) {
    super(
      [
        {
          verb: Verb.UpsertSubjectAttributeMany,
          subjectID: newShapeID,
          version: -1,
          attributes: makeAttributeList({
            ...shape,
            text: contents,
          }),
        },
      ],
      [
        {
          verb: Verb.DeleteShape,
          subjectID: newShapeID,
        },
      ]
    );
    this.shape = shape;
  }

  get label(): string {
    return `Add text`;
  }
}
